import { ShieldCheck, Lock, MapPin, HeartHandshake, BadgeCheck, Trophy } from "lucide-react";
import { Reveal } from "./Reveal";

const BADGES = [
  { icon: ShieldCheck, title: "Confidential Handling", text: "Your information is treated with discretion and respect." },
  { icon: Lock, title: "Secure HTTPS Connection", text: "Every form on this site is transmitted over an encrypted connection." },
  { icon: BadgeCheck, title: "Authorized IRS e-file Provider", text: "File electronically with an authorized provider for faster, more accurate returns." },
  { icon: Trophy, title: "Office of the Year 2026", text: "Recognized for our commitment to clients, our team and results." },
  { icon: MapPin, title: "Certified in All 50 States", text: "Certified to file taxes in all 50 states — wherever you are, we've got you covered." },
  { icon: HeartHandshake, title: "Client-First Service", text: "Simply good people providing exceptional service." },
];

export const TrustBadges = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-testid="trust-badges">
    {BADGES.map((b, i) => (
      <Reveal key={b.title} delay={i * 0.08}>
        <div className="lux-card p-7 h-full">
          <b.icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.4} />
          <h4 className="mt-5 text-lg font-medium" style={{ fontFamily: "Outfit" }}>{b.title}</h4>
          <p className="mt-2 text-sm text-white/60 leading-relaxed">{b.text}</p>
        </div>
      </Reveal>
    ))}
  </div>
);
